<app-header-component [headerData]="currentHeaderData" (closeModal)="closeModal()"></app-header-component>
<ion-content class="ion-padding-vertical">
  <div
    class="form ion-padding-horizontal"
    *ngIf="formQuestionData; else noQuestions"
  >
    <form [formGroup]="form" (submit)="submitRequest()">
      <div *ngFor="let item of formFields" class="”form-group”">
        <ion-item
          class="input-border ion-margin-bottom"
          *ngIf="item.field_type === 'string'"
        >
          <ion-input
            required
            autocomplete="off"
            [placeholder]="item.question"
            name="item['name']"
            class="”form-control”"
            [formControlName]="item.name"
          ></ion-input>
        </ion-item>
        <ion-item
          class="input-border ion-margin-bottom"
          *ngIf="item.field_type === 'email'"
        >
          <ion-input
            required
            autocomplete="off"
            [placeholder]="item.question"
            name="item['name']"
            type="email"
            class="”form-control”"
            [formControlName]="item.name"
          ></ion-input>
        </ion-item>
      <ion-item class="input-border ion-margin-bottom" *ngIf="item.field_type === 'int' && item.name === 'phone_number'">
        <ion-button (click)="selectCountryCode()" mode="ios" class="fs-4 ion-no-margin ion-margin-end ion-no-padding"
          fill="clear">
          {{ selectedCountryCode.flag }} {{ selectedCountryCode.dialCode }}
          <ion-icon class="fs-4 primary-icon-color" slot="end" name="chevron-down-outline"></ion-icon>
        </ion-button>
        <ion-input required autocomplete="off" [placeholder]="item.question" name="item['name']" type="number"
          class="”form-control”" [formControlName]="item.name"></ion-input>
      </ion-item>
        <ion-item
          class="input-border ion-margin-bottom"
          *ngIf="item.field_type === 'int' && item.name !== 'phone_number'"
        >
          <ion-input
            required
            autocomplete="off"
            [placeholder]="item.question"
            name="item['name']"
            type="number"
            class="”form-control”"
            [formControlName]="item.name"
          ></ion-input>
        </ion-item>
        <ion-item
          class="input-border ion-margin-top ion-margin-bottom"
          *ngIf="item.field_type === 'date'"
        >
          <ion-label class="date-label">{{ item.question }}</ion-label>
          <ion-input
            type="date"
            [min]="item.name === 'pickup_date' ? minPickupDate : ''"
            [max]="
              item.name === 'date_of_birth'
                ? validBdate
                : item.name === 'pickup_date'
                ? maxPickupDate
                : ''
            "
            [name]="item.name"
            required
            [placeholder]="item.question"
            [formControlName]="item.name"
          >
          </ion-input>
        </ion-item>
        <ion-item
          class="input-border ion-margin-top ion-margin-bottom"
          *ngIf="item.field_type === 'time'"
        >
          <ion-label class="time-label">{{ item.question }}</ion-label>
          <ion-input
            type="time"
            name="pickup_time"
            required
            [placeholder]="item.question"
            [formControlName]="item.name"
          >
          </ion-input>
        </ion-item>
        <ion-item
          class="input-border ion-margin-bottom"
          *ngIf="item.field_type === 'options'"
        >
          <ion-select
            class="ion-no-padding"
            required
            [placeholder]="item.question"
            [formControlName]="item.name"
            interface="popover"
          >
            <ion-select-option
              *ngFor="let element of item.optionList"
              value="{{ element }}"
              >{{ element }}</ion-select-option
            >
          </ion-select>
        </ion-item>
      </div>

      <ion-button
        type="submit"
        mode="ios"
        expand="block"
        [disabled]="form.invalid"
        class="place_order fs-4 font600"
        [ngClass]="{
          'secondary-btn': form.invalid,
          'primary-btn': !form.invalid
        }"
      >
       {{ "autocheckout_form.place_order" | translate }}
      </ion-button>
    </form>
  </div>

  <ng-template #noQuestions>
    <no-data
      [showModalCloseBtn]="true"
      [message]="'ERROR.auto_checkout' | translate"
    ></no-data>
  </ng-template>
</ion-content>
